import { useEffect, useState } from "react";
import { useHistory, useLocation } from "react-router-dom";

export type UrlActiveTab = (options: { default_active_tab: string }) => {
  active_tab: string;
  setActiveTab: React.Dispatch<React.SetStateAction<string>>;
};

export const useUrlActiveTab: UrlActiveTab = options => {
  const [active_tab, setActiveTab] = useState<string>(
    options.default_active_tab,
  );
  const location = useLocation();
  const history = useHistory();

  // set default active tab if not set, only at mount
  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const url_default_active_tab = params.get("active_tab");

    if (url_default_active_tab) {
      setActiveTab(url_default_active_tab);
    } else {
      params.set("active_tab", options.default_active_tab);
      history.replace({
        pathname: location.pathname,
        search: params.toString(),
      });
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  // update url when active tab changes
  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const url_active_tab = params.get("active_tab");

    if (active_tab && active_tab !== url_active_tab) {
      params.set("active_tab", active_tab);
      history.replace({
        pathname: location.pathname,
        search: params.toString(),
      });
    }
  }, [active_tab, location, history, location.search]);

  return {
    active_tab,
    setActiveTab,
  };
};
